import { parse, serialize } from 'cookie-es'
import { destr } from 'destr'
import { watch,ref } from 'vue';
const maxAgeTenYears = 10 * 365 * 24 * 60 * 60;
const CookieDefaults = {
  maxAge: maxAgeTenYears,
  sameSite: 'None',
  secure: true,
  path: '/',
  watch: true,
  decode: val => destr(decodeURIComponent(val)),
  encode: val => encodeURIComponent(typeof val === 'string' ? val : JSON.stringify(val)),
}

export const useCookie = (name, _opts) => {
  const opts = { ...CookieDefaults, ..._opts || {} }
  const cookies = parse(document.cookie, opts)
  let defaul = cookies[name] ?? opts.default?.()
  const cookie = ref(defaul)

  watch(cookie, () => {
    console.log('I set cookie for ', name)
    document.cookie = serializeCookie(name, cookie.value, opts)
  })
  
  return cookie
}
function serializeCookie(name, value, opts = {}) {
  if (value === null || value === undefined)
    return serialize(name, value, { ...opts, maxAge: -1 })
  console.log('im serializing', name, value)
  return serialize(name, value, opts)
}
